import store from '@/store';

export default class AgentWhatsAppLoginEvent {
  constructor(body) {
    if (body.whatsApp) {
      store.dispatch('channel/setConnectedInWhatsApp');
    } else {
      store.dispatch('showSnackbar', {
        text: 'errorConnectChannel',
        type: 'error',
      });
    }
  }
}
